export default __webpack_public_path__ + "static/media/tooltip.c69f6c8c.svg";